import { blocksByType } from '@ui/MarkdownEditor/editor/byType';

const isInline = ({ isInline: isInlineCore }) => {
  const inlineBlockTypes = new Set(Object.keys(blocksByType).filter(type => blocksByType[type].isInline));

  return element => element.isInline || inlineBlockTypes.has(element.type) || isInlineCore(element);
};

export default isInline;
